import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";
Vue.use(Vuetify);

export const options = {
  breakpoint: {
    mobileBreakpoint: "sm",
    thresholds: {
      sm: 1024
    }
  },

  theme: {
    options: {
      customProperties: true
    },
    dark: true,
    themes: {
      dark: {
        primary: "#5632af",
        edit: colors.blue,
        boomySlider: "#8F7AF0",
        secondary: "#272632"
      }
    }
  },

  icons: {
    iconfont: "mdiSvg"
  }
};

export default new Vuetify(options);
